module.exports = __webpack_public_path__ + "static/media/Books.d92c0f8c.jpg";